export const GET_ALL_USERS = 'GET_ALL_USERS'
export const GET_ALL_SELLERS = 'GET_ALL_SELLERS'
export const GET_SINGLE_USER = 'GET_SINGLE_USER'
export const GET_DASHBOARD_USER = 'GET_DASHBOARD_USER'
export const RESPONSE_STATUS = 'RESPONSE_STATUS'
export const CLEAR_RESPONSE = 'CLEAR_RESPONSE'
export const GET_ALL_BIDDING_USERS = 'GET_ALL_BIDDING_USERS'
export const GET_SINGLE_OWNER = 'GET_SINGLE_OWNER'
export const GET_CUSTOM_SINGLE_USER = 'GET_CUSTOM_SINGLE_USER'
